module.exports = __webpack_public_path__ + "static/media/cart.c30bcb43.svg";